import React, { useMemo } from "react";
import { Checkbox } from "antd";
import { Icon } from "Components";
import { PropertyOption } from "./Step3.types";
import DebounceInput from "PhishingManager/components/DebouncedInput";

interface Props {
  propertyOptions: PropertyOption[];
  selectedProperties: number[];
  setSelectedProperties: (propertyIds: number[]) => void;
  propertySearchQuery: string;
  setPropertySearchQuery: (value: string) => void;
}

const PropertyRecipients: React.FC<Props> = ({
  propertyOptions,
  selectedProperties,
  setSelectedProperties,
  propertySearchQuery,
  setPropertySearchQuery,
}) => {
  const allSelected = propertyOptions.length > 0 && selectedProperties.length === propertyOptions.length;

  const handleSelectAll = () => {
    if (allSelected) setSelectedProperties([]);
    else setSelectedProperties(propertyOptions.map((p) => p.value));
  };

  const handleToggle = (propertyId: number) => {
    if (selectedProperties.includes(propertyId)) setSelectedProperties(selectedProperties.filter((p) => p !== propertyId));
    else setSelectedProperties([...selectedProperties, propertyId]);
  };

  const totalCount = useMemo(() => {
    return propertyOptions.filter((p) => selectedProperties.includes(p.value)).reduce((acc, p) => acc + p.count, 0);
  }, [propertyOptions, selectedProperties]);

  return (
    <div className="phishing-step3__property-section">
      <div className="phishing-step3__property-search">
        <DebounceInput placeholder="Search properties" setDebouncedSearch={setPropertySearchQuery} />
      </div>

      <div className="phishing-step3__role-list-header">
        <div className="phishing-step3__label">
          Select properties ({propertyOptions.length})
          {totalCount > 0 && (
            <>
              <span className="phishing-step3__dot"> · </span>
              <span className="phishing-step3__total-count">
                {totalCount} user{totalCount > 1 ? "s" : ""} selected
              </span>
            </>
          )}  <span className="required"> * </span>
        </div>
        <button
          className="phishing-step3__select-all"
          onClick={handleSelectAll}
        >
          {allSelected ? "Deselect all" : "Select all"}
        </button>
      </div>

      <div className="phishing-step3__role-list">
        {propertyOptions.length === 0 ? (
          <div className="phishing-step3__role-item phishing-step3__role-item--empty">
            No properties found.
          </div>
        ) : propertyOptions.map((property) => (
          <div
            key={property.value}
            className="phishing-step3__role-item"
            onClick={() => handleToggle(property.value)}
          >
            <Checkbox
              checked={selectedProperties.includes(property.value)}
              onChange={() => handleToggle(property.value)}
              onClick={(e) => e.stopPropagation()}
            />
            <div className="phishing-step3__role-info">
              <div className="phishing-step3__role-title">
                <Icon type="recipientProperty" />
                {property.label}
              </div>
              <span className="phishing-step3__role-desc">
                {property.count} {`user${property.count > 1 ? "s" : ""}`}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyRecipients;